import { render } from "./Inventory_button.vue?vue&type=template&id=5c14e6de&scoped=true"
import script from "./Inventory_button.vue?vue&type=script&lang=js"
export * from "./Inventory_button.vue?vue&type=script&lang=js"

import "./Inventory_button.vue?vue&type=style&index=0&id=5c14e6de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c14e6de"]])

export default __exports__